import React from 'react'

const Burger = props => (
  <svg width='32' height='32' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M0 15h32v3H0zM0 5h32v3H0zm0 20h32v3H0z'
      fill='#2A2A2A'
      fillRule='evenodd'
    />
  </svg>
)

export default Burger



// WEBPACK FOOTER //
// ./src/svg-icons/Burger.js